import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';

const Hero = () => {
	const theme = useTheme();

	const styles = bgImage => ({
		position: 'absolute',
		objectFit: 'cover',
		/* support for plugin https://github.com/bfred-it/object-fit-images */
		fontFamily: 'object-fit: cover;',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		zIndex: -1,
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		backgroundPosition: 'center center',
		backgroundImage: `url(${bgImage})`,
		filter: theme.palette.mode === 'dark' ? 'brightness(0.9)' : 'none'
	});

	useEffect(() => {
		const jarallaxInit = async () => {
			const jarallaxElems = document.querySelectorAll('.jarallax');
			if (!jarallaxElems || (jarallaxElems && jarallaxElems.length === 0)) {
				return;
			}

			const { jarallax } = await import('jarallax');
			jarallax(jarallaxElems, { speed: 0.2 });
		};
		jarallaxInit();
	});

	return (
		<Box display='flex' flexDirection={'column'}>
			<Box
				sx={{
					position: 'relative',
					backgroundColor: theme.palette.primary.main
					/*
					marginTop: -13, 
					paddingTop: 13 
					*/
				}}>
				<Box
					className={'jarallax'}
					data-jarallax
					data-speed='0.2'
					position={'relative'}
					display={'flex'}
					alignItems={'center'}
					id='agency__portfolio-item--js-scroll'>
					<Box
						className={'jarallax-img'}
						sx={styles(
							'https://thumbs.dreamstime.com/b/international-team-doctors-having-morning-breefing-cheerful-international-team-doctors-having-morning-breefing-male-231917563.jpg'
						)}
					/>
					<Box
						display='flex'
						flexDirection={'column'}
						justifyContent='center'
						alignItems={'center'}
						alignContent='center'
						height={1}
						width={1}>
						<Box
							width={1}
							height={1}
							sx={{
								bgcolor: alpha(theme.palette.primary.main, 0.8)
							}}
							display='flex'
							flexDirection={'column'}
							justifyContent={'flex-end'}
							alignContent={'center'}
							alignItems={'center'}>
							<Box marginTop={8} padding={0}>
								<Box>
									<Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
										<SimTypography
											variant='h3'
											color={theme.palette.background.default}
											gutterBottom
											align={'center'}
											sx={{
												fontWeight: 400
											}}>
											Work with us
										</SimTypography>
										<SimTypography
											variant='h6'
											component='p'
											color={theme.palette.background.default}
											align={'center'}
											sx={{ marginBottom: 2 }}>
											Work hard with highly motivated team of talented people and great teammates
											to
											<br />
											create a real difference to lives of special needs children & their families
										</SimTypography>
										<SimButton
											variant='contained'
											backgroundColor='secondary'
											color='primary'
											size='large'
											endIcon={
												<svg
													width={16}
													height={16}
													xmlns='http://www.w3.org/2000/svg'
													fill='none'
													viewBox='0 0 24 24'
													stroke='currentColor'
													// bgcolor={theme.palette.alternate.main}
													>
													<path
														strokeLinecap='round'
														strokeLinejoin='round'
														strokeWidth={2}
														d='M17 8l4 4m0 0l-4 4m4-4H3'
														// bgcolor={theme.palette.primary.main}
													/>
												</svg>
											}>
											See job openings
										</SimButton>
									</Box>
								</Box>
							</Box>

							<Box
								id='dividerFinal'
								height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
								marginTop={{ xs: '5vh', sm: '5vw', lg: '5vw' }}
								marginBottom={0}
								paddingBottom={0}>
								<Box
									marginBottom={0}
									paddingBottom={0}
									height={{ xs: '15vh', md: '10vw', lg: '10vw' }}
									component={'svg'}
									preserveAspectRatio='none'
									xmlns='http://www.w3.org/2000/svg'
									x='0px'
									y='0px'
									viewBox='0 0 1920 100.1'
									sx={{
										marginBottom: -1,
										width: 1
									}}>
									<path
										fill={theme.palette.background.transparentDefault}
										d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
								</Box>
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default Hero;
